// extracted by mini-css-extract-plugin
export default {"buttonStyle":"CustomButtonRedBg_buttonStyle__v9ylL"};